import * as React from "react";
import { ChangeEvent, useRef, useState } from "react";
import { Button, Grid, TextField } from "@mui/material";
import { addMessageAction } from "sb-material-components";
import { COLORS } from "../../theme";
import { useDispatch } from "react-redux";
import {
    BriefId,
    createFormFields,
    SubscriberId,
    useSubmitFormMutation,
} from "../../app/services/subscriberFeedbackApi";
import { Recaptcha } from "./Recaptcha";
import ReCAPTCHA from "react-google-recaptcha";

function FeedbackMessageTextField(props: {
    value: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}) {
    return (
        <TextField
            id="feedback-message"
            value={props.value}
            onChange={props.onChange}
            multiline
            rows={12}
            inputProps={{
                maxLength: 500,
                "data-testid": "feedback-message-item",
            }}
            sx={{ width: 1 }}
        />
    );
}

function FeedbackSubjectTextField(props: {
    value: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}) {
    return (
        <TextField
            id="feedback-subject"
            value={props.value}
            onChange={props.onChange}
            inputProps={{
                maxLength: 100,
                "data-testid": "feedback-subject-item",
            }}
            sx={{ width: 1 }}
        />
    );
}

export default function FeedbackForm(props: { briefId: BriefId; subscriberId: SubscriberId }) {
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");
    const ref = useRef<ReCAPTCHA>();

    const handleSubjectChange = (event: ChangeEvent<HTMLInputElement>) => {
        setSubject(event.target.value);
    };

    const handleMessageChange = (event: ChangeEvent<HTMLInputElement>) => {
        setMessage(event.target.value);
    };
    const dispatch = useDispatch();
    const [submitForm, { isLoading: formIsLoading }] = useSubmitFormMutation();

    const handleSubmit = async () => {
        ref.current!.executeAsync().then((value) => {
            const formFields = createFormFields(props.briefId, props.subscriberId, subject, message, value!);
            submitForm(formFields);
            //TODO: need exception handling here
            dispatch(
                addMessageAction({
                    type: "success",
                    text: "Thank you! Your feedback has been received",
                    persistent: false,
                }),
            );
            setSubject("");
            setMessage("");
        });
    };

    return (
        <Grid item xs={10} justifyContent={"center"} sx={{ backgroundColor: COLORS.WHITE }}>
            <Grid container justifyContent={"center"} direction="column">
                <Grid item xs={12} alignContent={"center"}>
                    <h2>Contact the editor </h2>
                </Grid>

                <Grid item xs={4} py={0}>
                    <h4>Subject</h4>
                </Grid>
                <Grid item xs={8} py={0}>
                    <FeedbackSubjectTextField value={subject} onChange={handleSubjectChange} />
                </Grid>
                <Grid item xs={4}>
                    <h4>Message</h4>
                </Grid>
                <Grid item xs={8}>
                    <FeedbackMessageTextField value={message} onChange={handleMessageChange} />
                </Grid>
                <Grid item xs={4}>
                    <Recaptcha recaptchaRef={ref} />
                </Grid>
                <Grid item xs={8} py={2}>
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        disabled={formIsLoading || !subject.length || !message.length}
                    >
                        Submit
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    );
}
